import { render, staticRenderFns } from "./MCQTypeSelect.vue?vue&type=template&id=5d359342&"
import script from "./MCQTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./MCQTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports